import { Link } from 'react-router-dom';
import FloatingLeaves from './FloatingLeaves';
import { PalmTree, HalalSeal } from './KeralaDecor';
import site from '../data/site';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero__bg" aria-hidden="true">
        <div
          className="hero__leaf-tile"
          style={{ backgroundImage: 'url(/decor/leaf-pattern-tile.svg)' }}
        ></div>
        <div className="hero__vignette"></div>
      </div>
      <FloatingLeaves count={8} />
      <PalmTree side="left" height={420} opacity={0.55} />
      <PalmTree side="right" height={420} opacity={0.55} />

      <div className="container hero__inner">
        <div className="hero__frame">
          <span className="eyebrow-script hero__eyebrow">{site.brandLines.eyebrow}</span>
          <h1 className="hero__title">
            <span className="hero__title-h">H</span><span className="hero__title-2">2</span>
            <span className="hero__title-fresh"> FRESH</span>
          </h1>
          <p className="hero__sub">{site.brandLines.subhead}</p>
          <p className="hero__tagline">{site.tagline}</p>

          <div className="hero__seal-wrap">
            <HalalSeal size={120} />
            <span className="hero__seal-caption">Zabiha Halal Certified</span>
          </div>

          <div className="hero__cta">
            <Link to="/menu" className="btn btn-gold">View the Menu</Link>
            <Link to="/market" className="btn btn-ghost">Shop the Market</Link>
          </div>

          <div className="hero__pillars">
            <span><span aria-hidden="true">🍛</span> Authentic Kerala Cuisine</span>
            <span className="hero__pillar-divider">·</span>
            <span><span aria-hidden="true">🥩</span> Fresh Halal Meat</span>
            <span className="hero__pillar-divider">·</span>
            <span><span aria-hidden="true">🍽️</span> Dine-In & Takeout</span>
          </div>
        </div>
      </div>

    </section>
  );
}
